import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEvent } from '@interfaces/IEvent';
import { IUser } from '@interfaces/IUser';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private _http: HttpClient) {}

  createEvent(event: IEvent): Observable<{ detail: string; id: number }> {
    const url = `${environment.baseUrl}api/v1/events/`;
    return this._http.post<{ detail: string; id: number }>(url, event);
  }

  deleteEventFile(id: number): Observable<null> {
    const url = `${environment.baseUrl}api/v1/event-files/${id}`;
    return this._http.delete<null>(url);
  }

  addEventMaterial(eventId: number, type: string): Observable<{ id: number }> {
    const url = `${environment.baseUrl}api/v1/events/${eventId}/materials/`;
    return this._http.post<{ id: number }>(url, { type });
  }

  addEventVisits(
    eventId: number,
    students: number[]
  ): Observable<{ student: IUser }[]> {
    const url = `${environment.baseUrl}api/v1/events/${eventId}/visits/`;
    return this._http.post<{ student: IUser }[]>(url, { students });
  }

  getEventVisits(eventId: number): Observable<{ visits: IUser[] }> {
    const url = `${environment.baseUrl}api/v1/events/${eventId}/visits/`;
    return this._http.get<{ visits: IUser[] }>(url);
  }

  getEvent(eventId: number): Observable<{ is_live: boolean }> {
    return this._http.get<{ is_live: boolean }>(
      `${environment.baseUrl}api/v1/events/${eventId}`
    );
  }
}
